import reglesAchatTranslator from '@/services/catalogue/validation/champsReglesAchatTranslator';
import objectifsVenteTranslator from '@/services/catalogue/validation/champsObjectifVenteTranslator';
import commissionsVendeurTranslator from '@/services/catalogue/validation/champsCommissionsVendeurTranslator';
import cgvsTranslator from '@/services/catalogue/validation/champsCgvsTranslator';

export default function translate(i18n, propriete) {
  if (propriete === 'code') return i18n.t('addEditRegroupementProduit.information.code');
  if (propriete === 'libelle') return i18n.t('addEditRegroupementProduit.information.libelle');
  if (propriete.indexOf('reglesAchat') !== -1) return reglesAchatTranslator(i18n, propriete);
  if (propriete.indexOf('objectifsVente') !== -1) return objectifsVenteTranslator(i18n, propriete);
  if (propriete.startsWith('commissionsVendeur')) return commissionsVendeurTranslator(i18n, propriete);
  if (propriete.startsWith('cgvs')) return cgvsTranslator(i18n, propriete);
  return propriete;
}
